const greenhouseAPI = async () => {
  const apiSection = document.querySelector('.job-listings-greenhouse-api');
  const apiCall = apiSection?.getAttribute('data-api-call');
  const apiJobID = apiSection?.getAttribute('data-api-job-id');
  const apiRegion = apiSection?.getAttribute('data-api-region');
  const apiSource = apiSection?.getAttribute('data-api-source');
  const listingGrid = document.querySelector('[data-job-listing-grid]');
  const textTags = ['p', 'h2'];

  if (apiSection && apiCall == 'all') {
    const response = await fetch(
      `https://boards-api.greenhouse.io/v1/boards/${apiRegion}/jobs`
    );
    const jsonData = await response.json();
    const jobs = jsonData.jobs;

    jobs.forEach((job: any) => {
      const dateObj = new Date(job.updated_at);
      const dateFormat = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };
      // @ts-ignore
      const date = dateObj.toLocaleDateString('en-gb', dateFormat);

      const listing = `
      <div class="grid__column">
        <article class="job-listing__card" data-job-listing-article>
          <div class="job-listing__regions">
            <span class="job-listing__region">${job.location.name}</span>
          </div>
          <a class="job-listing__title h4 mb-3" href="${apiSource}/?region=${apiRegion}&gh_jid=${job.id}">${job.title}</a>
          <p class="job-listing__details">
            <span class="job-listing__date">
              Updated: ${date}
            </span>
          </p>
          <a class="job-listing__link" href="${apiSource}/?region=${apiRegion}&gh_jid=${job.id}">Apply Now<i class="h6 far fa-long-arrow-right margin-left--xs"></i></a>
        </article>
      </div>`;

      listingGrid.innerHTML = listingGrid.innerHTML + listing;
    });
  } else if (apiSection && apiCall == 'single') {
    const htmlDecode = (input: string) => {
      const e = document.createElement('div');
      e.innerHTML = input;
      return e.childNodes[0].nodeValue;
    };

    const response = await fetch(
      `https://boards-api.greenhouse.io/v1/boards/${apiRegion}/jobs/${apiJobID}`
    );

    const jsonData = await response.json();
    const applicationurl = jsonData.absolute_url;
    const applicationLink = `<div class="ctas"><div class="ctas__container"><ul class="ctas__ul"><li><a class="cta cta--button cta--button-navy-blue" href="${applicationurl}" target="_blank">Apply Now&nbsp;<i class="far fa-long-arrow-right"></i></a></li></ul></div></div>`;
    const dateObj = new Date(jsonData.updated_at);
    const dateFormat = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    // @ts-ignore
    const date = dateObj.toLocaleDateString('en-gb', dateFormat);

    const htmlContent = htmlDecode(jsonData.content) + applicationLink;

    document.querySelector('[data-job-listing-title]').innerHTML =
      jsonData.title;
    document.querySelector('[data-job-listing-region]').innerHTML =
      jsonData.location.name;
    document.querySelector(
      '[data-job-listing-date]'
    ).innerHTML = `Updated: ${date}`;
    document.querySelector('[data-job-listing-description]').innerHTML =
      htmlContent;

    textTags.forEach((textTag) => {
      const tagElements = document.querySelectorAll(textTag);
      tagElements.forEach((element) => {
        const text = element.textContent;
        if (text == '&nbsp;' || text == '\xa0') {
          element.remove();
        }
      });
    });

    document
      .querySelector('[data-single-job-listing]')
      .classList.remove('grid__column--hidden');
  }
};

export default greenhouseAPI;
